<template>
  <div
    class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end"
  >
    <div
      class="modal-content rounded-none bg-[#f8f8f8] py-[40px] px-[20px] md:px-[32px] h-[100dvh]"
    >
      <div class="modal-header flex items-start justify-between p-0 m-0">
        <h4
          class="font-semibold text-[18px] leading-[21.6px] capitalize text-[#353535] pb-[16px]"
        >
          Filter
        </h4>
        <button
          class="text-2xl text-[#353535] outline-none focus:outline-none"
          type="button"
          data-dismiss="modal"
          aria-hidden="true"
        >
          <span class="mdi mdi-close"></span>
        </button>
      </div>

      <div class="p-0 m-0">
        <div class="pb-[16px]">
          <label class="text-[#353535] font-medium text-[14px] leading-[20px]"
            >View By</label
          >

          <div>
            <select
              v-model="dateRangeType"
              class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
              @input="onSelectDateRangeType($event.target.value)"
            >
              <option v-for="item of dateRangeTypes" :key="item">
                {{ item }}
              </option>
            </select>
          </div>
        </div>

        <div
          v-if="dateRangeType == 'Custom' || dateRangeType == 'As at Date'"
          class="pb-[16px]"
        >
          <label
            class="text-[#353535] font-medium text-[14px] leading-[20px]"
            >{{ dateRangeType == "As at Date" ? "Date" : "Date range" }}</label
          >
          <div v-if="dateRangeType != 'As at Date'">
            <input
              type="date"
              :max="maxDate"
              class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
              placeholder="Select a date"
              v-model="filter.dateStart"
            />
          </div>
          <div>
            <input
              type="date"
              :max="maxDate"
              class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
              placeholder="Select a date"
              v-model="filter.dateEnd"
            />
          </div>
        </div>

        <div v-if="extraDataType == 'TEXT'" class="pb-[16px]">
          <label
            class="text-[#353535] font-medium text-[14px] leading-[20px]"
            >{{ extraDataLabel }}</label
          >
          <div>
            <input
              class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
              type="text"
              :placeholder="extraDataPlaceholder"
              v-model="filter.qry"
              @input="update"
            />
          </div>
        </div>

        <div class="pb-[16px]">
          <label class="text-[#353535] font-medium text-[14px] leading-[20px]"
            >Order Stages</label
          >
          <div>
            <v-select
              id="stageSelector"
              class="style-chooser"
              multiple
              :options="stageOptions"
              v-model="filter.stages"
              :reduce="(value) => value.id"
              @input="isSelectStage($event)"
            />
          </div>
        </div>

        <div class="pb-[16px]">
          <label class="text-[#353535] font-medium text-[14px] leading-[20px]"
            >Distributor</label
          >
          <div>
            <input
              class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
              type="text"
              placeholder="Distributor name"
              v-model="filter.distributor"
              @input="update"
            />
          </div>
        </div>

        <div v-if="extraDataType == 'LIST'" class="pb-[16px]">
          <label
            class="text-[#353535] font-medium text-[14px] leading-[20px]"
            >{{ extraDataLabel }}</label
          >
          <div>
            <select
              class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
              v-model="filter.status"
              @change="update"
            >
              <option
                v-for="(item, index) of extraDataList"
                :key="item.value"
                :selected="index === 0"
                :value="item.value"
              >
                {{ item.text }}</option
              >
            </select>
          </div>
        </div>
      </div>
      <div class="flex items-center gap-[8px] w-full mt-[24px]">
        <button
          class="bg-[#fcfcfd] border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-[#96A0B5] font-medium leading-[20px] w-full outline-none focus:outline-none"
          type="button"
          data-dismiss="modal"
        >
          Cancel
        </button>
        <button
          class="bg-[#fcfcfd] border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-[#96A0B5] font-medium leading-[20px] w-full outline-none focus:outline-none"
          type="button"
          @click="reset"
        >
          Reset
        </button>
        <button
          class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-white font-medium leading-[20px] w-full outline-none focus:outline-none"
          type="button"
          @click="
            onSearch();
            searchFn();
          "
        >
          Search
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { helper } from "@/helper";
import vSelect from "vue-select";

export default {
  name: "ReportFilterModal",
  components: { vSelect },
  props: {
    extraDataType: { type: String, default: "NONE" }, // NONE or TEXT or LIST,
    extraDataLabel: { type: String, default: "Search" }, // Put label of extradata here
    extraDataPlaceholder: { type: String, default: "Enter text to search" }, // Put placeholder of extradata here
    extraDataList: { type: Array, default: () => [] }, // if extradattype LIST put an array of {value:any, text:string} here
    searchFn: { type: Function },
  },
  data() {
    return {
      dateFormat: "yyyy-MM-DD",
      dateRangeTypes: [
        "Year Before Now",
        "Today",
        "This Month",
        "This Year",
        "As at Date",
        "Custom",
      ],
      dateRangeType: "Year Before Now",
      filter: {
        dateStart: moment()
          .subtract(1, "years")
          .format("yyyy-MM-DD"),
        dateEnd: moment().format("yyyy-MM-DD"),
        qry: "",
        status: "",
        stages: [],
        distributor: "",
      },
      maxDate: "",
      stageOptions: [],
    };
  },
  mounted() {
    this.getPurchaseOrderStages();
    if (this.$props.extraDataType == "LIST" && this.extraDataList.length > 0) {
      this.filter.status = this.extraDataList[0]["value"];
      this.update();
      this.maxDate = helper.preventFutureDateSelection();
    }
  },
  methods: {
    isSelectStage(e) {
      this.filter.stages = e;
      this.update();
    },
    async getPurchaseOrderStages() {
      await this.$http
        .get("/PurchaseOrders/orderStage/getList?active=true")
        .then(function(res) {
          this.stageOptions = res.body.map((item) => {
            return { id: item.id, label: item.name };
          });
        })
        .catch(function() {});
    },
    update() {
      this.$emit("input", this.filter);
    },
    onSearch() {
      this.$emit("onsearch");
    },
    reset() {
      this.filter = {
        dateStart: moment()
          .subtract(1, "years")
          .format(this.dateFormat),
        dateEnd: moment().format(this.dateFormat),
        qry: "",
        status: "",
        stages: [],
        distributor: "",
      };
      this.update();
    },
    onSelectDateRangeType(value) {
      switch (value) {
        case "Year Before Now":
          this.filter.dateStart = moment()
            .subtract(1, "years")
            .format(this.dateFormat);
          this.filter.dateEnd = moment().format(this.dateFormat);
          break;
        case "Today":
          this.filter.dateStart = moment()
            .startOf("day")
            .format(this.dateFormat);
          this.filter.dateEnd = moment()
            .endOf("day")
            .format(this.dateFormat);
          break;
        case "This Month":
          this.filter.dateStart = moment()
            .startOf("month")
            .format(this.dateFormat);
          this.filter.dateEnd = moment(this.filter.dateStart)
            .endOf("month")
            .format(this.dateFormat);
          break;
        case "As at Date":
          this.filter.dateStart = null;
          this.filter.dateEnd = moment()
            .endOf("day")
            .format(this.dateFormat);
          break;
        case "This Year":
          this.filter.dateStart = moment()
            .startOf("year")
            .format(this.dateFormat);
          this.filter.dateEnd = moment()
            .endOf("year")
            .format(this.dateFormat);
          break;
        case "Custom":
          break;
        default:
          break;
      }
      this.update();
    },
    inputFilterChange(value) {
      this.filter.qry = value;
      this.update();
    },
    dropDownFilterChange(value) {
      this.filter.status = value;
      this.update();
    },
  },
};
</script>

<style></style>
